import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function DecisionSection() {
  return <section className="py-24 bg-beige-light relative" data-id="element-26">
      <div className="container mx-auto px-6 max-w-4xl text-center" data-id="element-27">
        <FadeIn data-id="element-28">
          <h2 className="font-heading text-4xl md:text-5xl text-charcoal mb-8 text-balance" data-id="element-29">
            Puedes seguir intentando cambiar tu vida… o puedes descubrir qué la
            está controlando.
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12 text-left" data-id="element-30">
          <FadeIn delay={0.2} data-id="element-31">
            <div className="p-8 border border-charcoal/10 bg-white/50 rounded-sm" data-id="element-32">
              <h3 className="font-heading text-xl text-charcoal mb-4" data-id="element-33">
                Opción 1: Seguir igual
              </h3>
              <p className="font-body text-charcoal/70 mb-4" data-id="element-34">
                Puedes cerrar esta página y seguir intentando cambiar tu vida
                desde la superficie. Seguir tropezando con las mismas piedras,
                sintiendo esa frustración de no saber por qué te saboteas.
              </p>
              <p className="font-body text-charcoal/70" data-id="element-35">
                Y lo más doloroso: heredar estos mismos bloqueos a la siguiente
                generación.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-36">
            <div className="p-8 border-2 border-gold bg-white rounded-sm shadow-lg relative overflow-hidden" data-id="element-37">
              <div className="absolute top-0 right-0 w-16 h-16 bg-gold/10 rounded-bl-full" data-id="element-38" />
              <h3 className="font-heading text-xl text-terracotta mb-4" data-id="element-39">
                Opción 2: Romper el ciclo
              </h3>
              <p className="font-body text-charcoal/80 mb-4" data-id="element-40">
                Decidir que <strong data-id="element-41">contigo termina</strong>. Tomar las
                herramientas para mirar tu historia de frente, honrar a tus
                ancestros y devolverles sus cargas.
              </p>
              <p className="font-body text-charcoal/80 font-medium" data-id="element-42">
                Elegir la libertad emocional para ti, y para los que vienen
                después.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}